const FIELD_CONTAINER_SELECTOR = '.js-field-number-container';
const FIELD_SELECTOR = '.js-field-number';
const DECREASE_CONTROL = '.js-field-decrease';
const INCREASE_CONTROL = '.js-field-increase';

var decreaseButtons = document.querySelectorAll(DECREASE_CONTROL);
var increaseButtons = document.querySelectorAll(INCREASE_CONTROL);

decreaseButtons.forEach(function setEventListenerToTriggerFieldChange(button) {
    button.addEventListener('click', function (event) {
        controlsProcessing(event.target, decreaseValue);
    });
});

increaseButtons.forEach(function setEventListenerToTriggerFieldChange(button) {
    button.addEventListener('click', function (event) {
        controlsProcessing(event.target, increaseValue);
    });
});


function controlsProcessing(button, action) {
    var container = button.closest(FIELD_CONTAINER_SELECTOR);

    if (container) {
        var field = container.querySelector(FIELD_SELECTOR);

        if (field) {
            action(field);
        } else {
            throw new Error(`${container} must contain ${FIELD_SELECTOR}`);
        }
        
    } else {
        throw new Error(`${button} must be wrapped at ${FIELD_CONTAINER_SELECTOR}`);
    }
}


function increaseValue(field) {
    const max = +field.getAttribute('max');
    const currentFieldValue = +field.value;

    if (currentFieldValue < max) {
        field.value = currentFieldValue + 1;
    }
}


function decreaseValue(field) {
    const min = +field.getAttribute('min');
    const currentFieldValue = +field.value;

    if (currentFieldValue > min) {
        field.value = currentFieldValue - 1;
    }
}